import apiService from "./apiService";
import AppConstants from "../appConstants";

class ContentService {
    getContentNotification(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_CONTENT_NOTIFICATION, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    getPrivacyPolicyCustom(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_PRIVACY_POLICY_CONTENT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
}

export default new ContentService();